import React, { useEffect, useState } from "react";

/**
 * LocalTimeIndicator — browser-timezone-aware live clock.
 * Refreshes every 30s. No backend, no external API.
 * Two variants: `compact` (default, for top bar) and `hero` (for dashboard header).
 */
const format = () => {
  const now = new Date();
  const time = new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(now);

  const dateParts = new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZoneName: "short",
  }).formatToParts(now);

  const weekday = dateParts.find((p) => p.type === "weekday")?.value || "";
  const month = dateParts.find((p) => p.type === "month")?.value || "";
  const day = dateParts.find((p) => p.type === "day")?.value || "";
  const tz = dateParts.find((p) => p.type === "timeZoneName")?.value || "";

  return { time, dateLine: `${weekday}, ${month} ${day} · ${tz}` };
};

export const LocalTimeIndicator = ({ variant = "compact" }) => {
  const [t, setT] = useState(format());

  useEffect(() => {
    const id = setInterval(() => setT(format()), 30_000);
    return () => clearInterval(id);
  }, []);

  if (variant === "hero") {
    return (
      <div className="flex items-baseline gap-2 tabular" data-testid="local-time-hero">
        <span
          className="text-[15px] font-semibold"
          style={{ color: "var(--fg-primary)" }}
          data-testid="local-time-value"
        >
          {t.time}
        </span>
        <span className="text-[11.5px]" style={{ color: "var(--fg-muted)" }}>
          {t.dateLine}
        </span>
      </div>
    );
  }

  return (
    <div
      className="hidden md:flex flex-col items-end leading-tight text-right tabular"
      data-testid="local-time"
    >
      <span
        className="text-[13px] font-semibold"
        style={{ color: "var(--fg-primary)" }}
        data-testid="local-time-value"
      >
        {t.time}
      </span>
      <span className="text-[10.5px]" style={{ color: "var(--fg-muted)" }}>
        {t.dateLine}
      </span>
    </div>
  );
};
